module.exports = __webpack_public_path__ + "img/back01.5fff5950.png";